import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog'
import { Button } from '../ui/button'
import { useMutation } from '@tanstack/react-query'
import { trialDowngradePlanTrialDowngradePlanPostMutation } from '@/generated/@tanstack/react-query.gen'
import { toast } from 'react-toastify'
import { parseProfileResponse, useAuth } from '@/hooks/getAuth'
import Spinner from '../Spinner'

interface Props {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  handleViewPlans: () => void
}

export default function TrialDowngradeModal({
  isOpen,
  onOpenChange,
  handleViewPlans,
}: Props) {
  const { auth } = useAuth()
  const { setAuth, setIsLoggedIn } = useAuth()

  const saveLocalStorage = (response: any) => {
    const userCredential = parseProfileResponse(response)
    localStorage.setItem('auth', JSON.stringify(userCredential || {}))
    setAuth(userCredential)
    setIsLoggedIn(!!userCredential)
    window.location.reload()
  }

  const { mutate, isPending } = useMutation({
    ...trialDowngradePlanTrialDowngradePlanPostMutation({}),
    onSuccess: (response: any) => {
      if (response.status === 'fail') {
        return toast.error(response.msg)
      }
      saveLocalStorage(response)
    },
  })

  const handleDowngradeToBasic = () => {
    mutate({
      body: {
        session_key: auth.sessionKey,
      },
    })
  }

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent showClose={true} className="max-w-[440px] !p-8 rounded-lg">
        <DialogHeader>
          <DialogTitle className="md:text-2xl">Are you sure?</DialogTitle>
        </DialogHeader>
        {isPending && (
          <div>
            <Spinner />
          </div>
        )}
        <p>
          We would hate to see you miss out on everything HydraScore has to
          offer and would like to offer you a one-time discount of 20% off your
          subscription.
        </p>
        <DialogFooter className="flex sm:flex-col gap-4">
          <Button className="h-14 w-full text-lg" onClick={handleViewPlans}>
            Yes! I would love 20% off
          </Button>
          <Button
            variant={'ghost'}
            className="!py-0 !h-fit text-sm font-normal"
            onClick={handleDowngradeToBasic}
          >
            No, I’m good. Thanks
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
